export function saveCurrentLevelLocally(currentState) {
	//console.log("Saving Level: " + currentState);
	//console.log('saving state:' + currentState + ' in local storage');
	//localStorage.setItem('savedState', currentState);
}
//export function calculateScaleFactor(scene)
export function updateMiniLevel(currentMiniLevel) {
	// Update mini level
	currentMiniLevel += 1
	saveCurrentMiniLevelLocally(currentMiniLevel)
}

export function saveCurrentMiniLevelLocally(currentMiniLevel) {
	console.log("Save Current Mini Level: " + currentMiniLevel)
	let userData

	if (localStorage.getItem("userData") !== null) {
		//console.log('DataExists We Can Save');
		userData = JSON.parse(localStorage.getItem("userData"))

		userData.userMiniLevel = currentMiniLevel

		localStorage.setItem("userData", JSON.stringify(userData))
	} else {
		console.log("!!!DATA DOESN'T EXIST!!!")
	}
}

// export function saveUserCreatureDataLocally(creatureData) {
// 	let userCreatureData
// 	if (localStorage.getItem("userCreatureData") !== null) {
// 		userCreatureData = JSON.parse(localStorage.getItem("userCreatureData"))
// 		userCreatureData.creatures = creatureData.creatures
// 		localStorage.setItem("userCreatureData", JSON.stringify(userCreatureData))
// 	} else {
// 		userCreatureData = {
// 			creatures: creatureData.creatures,
// 		}
// 		localStorage.setItem("userCreatureData", JSON.stringify(userCreatureData))
// 	}
// }

export function loadUserCreatureDataLocally() {
	let userCreatureData
	if (localStorage.getItem("userCreatureData") !== null) {
		userCreatureData = JSON.parse(localStorage.getItem("userCreatureData"))
	} else {
		userCreatureData = {
			creatures: [],
		}
		localStorage.setItem("userCreatureData", JSON.stringify(userCreatureData))
	}
	return userCreatureData
}
export function saveUserCreatureDataLocally(creatureData) {
	let userCreatureData = localStorage.getItem("userCreatureData")

	if (userCreatureData !== null) {
		const existingData = JSON.parse(userCreatureData)

		if (!Array.isArray(existingData.creatures)) {
			existingData.creatures = []
		}
		existingData.creatures.push(creatureData)

		localStorage.setItem("userCreatureData", JSON.stringify(existingData))
	} else {
		const newData = {
			creatures: [creatureData],
		}
		localStorage.setItem("userCreatureData", JSON.stringify(newData))
	}
}

export function updatePlanetData(currentPlanet) {
	saveCompletedAndUnlockedPlanets(currentPlanet + 1)
}

export function saveCompletedAndUnlockedPlanets(newPlanet) {
	let userData

	if (localStorage.getItem("userData") !== null) {
		userData = JSON.parse(localStorage.getItem("userData"))

		// Only update if the new planet is higher than what's already unlocked
		if (newPlanet > userData.planetsUnlocked) {
			console.log("New Planet!!!!")
			userData.planetsUnlocked = newPlanet
			userData.planetsCompleted = newPlanet - 1

			localStorage.setItem("userData", JSON.stringify(userData))
		}
	} else {
		console.log("!!!DATA DOESN'T EXIST!!!")
	}
}

export function saveCurrentPlanetLocally(currentPlanet) {
	//console.log("Current Planet: " + currentPlanet);
	let userData

	if (localStorage.getItem("userData") !== null) {
		//console.log('DataExists We Can Save');
		userData = JSON.parse(localStorage.getItem("userData"))

		userData.currentPlanet = currentPlanet

		localStorage.setItem("userData", JSON.stringify(userData))
	} else {
		console.log("!!!DATA DOESN'T EXIST!!!")
	}
}

export function saveEmailsOpenedLocally(emailsOpened) {
	let userData

	if (localStorage.getItem("userData") !== null) {
		//console.log('DataExists We Can Save');
		userData = JSON.parse(localStorage.getItem("userData"))

		userData.emailsOpened = emailsOpened

		localStorage.setItem("userData", JSON.stringify(userData))
	} else {
		console.log("!!!DATA DOESN'T EXIST!!!")
	}
}

export function saveAlertsOpenedLocally(alertOpened) {
	let userData

	if (localStorage.getItem("userData") !== null) {
		//console.log('DataExists We Can Save');
		userData = JSON.parse(localStorage.getItem("userData"))

		userData.alertsOpened[alertOpened] = true

		localStorage.setItem("userData", JSON.stringify(userData))
	} else {
		console.log("!!!DATA DOESN'T EXIST!!!")
	}
}

export function setAllAlertsToFalse() {
	let userData

	if (localStorage.getItem("userData") !== null) {
		//console.log('DataExists We Can Save');
		userData = JSON.parse(localStorage.getItem("userData"))

		// Set all alert properties to false
		userData.alertsOpened = {
			facialScan: false,
			securityCheck: false,
			restartDevice: false,
			reconnectDevice: false,
			robotAlert: false,
			otpAlert: false,
		}

		localStorage.setItem("userData", JSON.stringify(userData))
	} else {
		console.log("!!!DATA DOESN'T EXIST!!!")
	}
}

// export function updateDischargedCreaturesLocally(creatureToDischarge) {
//     let userData;

//     if (localStorage.getItem('userData') !== null) {
//         console.log('DataExists We Can Save');
//         userData = JSON.parse(localStorage.getItem('userData'));

//         userData.creaturesDischarged = creatureToDischarge;

//         localStorage.setItem('userData', JSON.stringify(userData));

//     }
//     else {

//         console.log("!!!DATA DOESN'T EXIST!!!")
//     }
// }

export function saveCreatureStatusLocally(
	creatureToUnlock,
	creatureToDischarge,
) {
	//How to use saveCreatureStatusLocally(7,4);
	//How to use saveCreatureStatusLocally(7,null);
	//How to use saveCreatureStatusLocally(null,4);
	let userData

	if (localStorage.getItem("userData") !== null) {
		//console.log('DataExists We Can Save');
		userData = JSON.parse(localStorage.getItem("userData"))

		if (
			creatureToUnlock &&
			!userData.creaturesUnlocked.includes(creatureToUnlock)
		) {
			userData.creaturesUnlocked.push(creatureToUnlock)
		}

		if (
			creatureToDischarge &&
			!userData.creaturesDischarged.includes(creatureToDischarge)
		) {
			userData.creaturesDischarged.push(creatureToDischarge)
		}

		localStorage.setItem("userData", JSON.stringify(userData))
	} else {
		console.log("!!!DATA DOESN'T EXIST!!!")
	}
}

export function loadLevel(level, scene) {
	//console.log("Next Level: " + level);

	switch (level) {
		case 0:
			loginLevel(scene)
			break
		case 1:
			tutorialLevel(scene)
			break
		case 2:
			cockpitLevel(scene)
			break
		default:
			scene.scene.start("PlanetSelector")
			break
	}
}

export function loginLevel(scene) {
	//console.log('Login Start');
	scene.scene.start("LoginScene")
}
export function tutorialLevel(scene) {
	//console.log('Tutorial Start');

	//Select 1st Planet
	scene.scene.start("PlanetSelector")
}

export function cockpitLevel(scene) {
	scene.scene.start("CockpitScene")
}

export function deleteSaveData() {
	//setAllAlertsToFalse()
	let userData
	if (localStorage.getItem("userData") !== null) {
		// userData = JSON.parse(localStorage.getItem("userData"))

		// //Debugging
		// localStorage.removeItem("userData")

		// userData = null

		let newJSON = {
			userID: "",
			userLevel: 0,
			userMiniLevel: 0,
			planetsUnlocked: 0,
			planetsCompleted: 0,
			currentPlanet: 0,
			customizationCompleted: "false",
			customization: {
				tribe: "",
				rocket: "",
				ornament: "",
			},
			creatureActive: 0,
			creaturesUnlocked: [1],
			creaturesDischarged: [],
			emailsOpened: 0,
			alertsOpened: {
				facialScan: false,
				securityCheck: false,
				restartDevice: false,
				reconnectDevice: false,
				robotAlert: false,
				otpAlert: false,
			},
			onboardingCompleted: false,
			planetsUnlockAnimationShown: [],
		}

		userData = newJSON

		console.log("Reset All Data")

		localStorage.setItem("userData", JSON.stringify(userData))
	}
}

export function checkLocalSavedData() {
	let userData

	if (localStorage.getItem("userData") !== null) {
		userData = JSON.parse(localStorage.getItem("userData"))
		// console.log('We checked DataExists');
		// console.log(userData);
	} else {
		//userData = StartScene.cache.json.get('userData');
		let newJSON = {
			userID: "",
			userLevel: 0,
			userMiniLevel: 0,
			planetsUnlocked: 0,
			planetsCompleted: 0,
			currentPlanet: 0,
			customizationCompleted: "false",
			customization: {
				tribe: "",
				rocket: "",
				ornament: "",
			},
			creatureActive: 0,
			creaturesUnlocked: [1],
			creaturesDischarged: [],
			emailsOpened: 0,
			alertsOpened: {
				facialScan: false,
				securityCheck: false,
				restartDevice: false,
				reconnectDevice: false,
				robotAlert: false,
				otpAlert: false,
			},
			onboardingCompleted: false,
			planetsUnlockAnimationShown: [],
		}

		userData = newJSON

		console.log("No Data Exists. 1st User Experience. Create New User Data:")

		localStorage.setItem("userData", JSON.stringify(userData))
	}
	return userData
}

export function createStoryPanel(scene, options) {
	// Default options
	const defaults = {
		xScale: 1.2,
		yScale: 1.4,
		titles: ["Page 1"],
		content: ["Content goes here"],
		nextSceneKey: null,
		onComplete: null,
		buttonWidth: 80,
		buttonHeight: 80,
		fontSize: 20,
		nextButtonText: "Next",
		finalButtonText: "LET'S GO!",
		yOffset: 80,
		indicatorYOffset: 150,
		missionOutro: false,
		titleXPos: 300,
		titleYPos: 120,
		titleFontScale: 3,
		contentFontScale: 2,
		contentYOffset: 3,
		wrapWidth: 0.7,
		showPageIndicators: true, // Option to hide page indicators completely
		adjustContentSpace: true, // Whether to adjust content position when title is empty
		indicator: false,
	}

	// Merge options with defaults
	const config = { ...defaults, ...options }
	// Initialize properties
	const state = {
		currentPage: 0,
		totalPages: config.titles.length,
		pageIndicators: [],
		container: scene.add.container(scene.safeZoneX, scene.safeZoneY),
		originalYPos: 0,
		originalButtonPos: null, // Store original button position
		originalTextPos: null,   // Store original text position
	}

	// Create background panel
	const storyBG = scene.add
		.image(scene.safeZoneWidth / 2, scene.safeZoneHeight / 2, "wideContainer")
		.setScale(
			config.xScale * scene.scaleFactor,
			config.yScale * scene.scaleFactor,
		)

	state.container.add(storyBG)

	// Create title text using BBCode
	const storyTitle = scene.add
		.rexBBCodeText(
			storyBG.x - config.titleXPos * scene.scaleFactor,
			storyBG.y - config.titleYPos * scene.scaleFactor,
			"",
			{
				fontSize:
					Math.round(
						scene.fontSize + config.titleFontScale * scene.scaleFactor,
					) + "px",
				color: "#11044E",
				fontFamily: '"Gluten", sans-serif',
				resolution: 2,
			},
		)
		.setOrigin(0, 0.5)
	state.container.add(storyTitle)

	// Create content text using BBCode
	const storyContent = scene.add
		.rexBBCodeText(
			storyBG.x,
			storyBG.y + config.contentYOffset * scene.scaleFactor,
			"",
			{
				fontSize:
					Math.round(
						scene.fontSize + config.contentFontScale * scene.scaleFactor,
					) + "px",
				color: "#11044E",
				fontFamily: '"Space Grotesk", sans-serif',
				align: "left",
				resolution: 2,
				wrap: {
					mode: "word",
					width: scene.safeZoneWidth * config.wrapWidth,
				},
			},
		)
		.setOrigin(0.5)

	state.container.add(storyContent)
	state.originalYPos = storyContent.y

	// Store references to text objects
	state.storyTitle = storyTitle
	state.storyContent = storyContent

	// Create navigation buttons
	const scaledButtonWidth = config.buttonWidth * scene.scaleFactor
	const scaledButtonHeight = config.buttonHeight * scene.scaleFactor

	// Create button container to manage as a group
	state.buttonContainer = scene.add.container(0, 0)
	state.container.add(state.buttonContainer)

	// Back button
	const backButton = scene.add
		.image(
			scene.safeZoneWidth / 2 - 200 * scene.scaleFactor,
			storyBG.y + config.yOffset * scene.scaleFactor,
			"backButton",
		)
		.setDisplaySize(scaledButtonWidth, scaledButtonHeight)
		.setInteractive()
		.on("pointerover", () => backButton.setTint(0xdddddd))
		.on("pointerout", () => backButton.clearTint())

	state.buttonContainer.add(backButton)

	// Next button
	const nextButton = scene.add
		.image(
			scene.safeZoneWidth / 2 + 200 * scene.scaleFactor,
			storyBG.y + config.yOffset * scene.scaleFactor,
			"forwardButton",
		)
		.setDisplaySize(scaledButtonWidth, scaledButtonHeight)
		.setInteractive()
		.on("pointerover", () => nextButton.setTint(0xdddddd))
		.on("pointerout", () => nextButton.clearTint())

	state.buttonContainer.add(nextButton)

	const isMobile =
		/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
			navigator.userAgent,
		)

	let tipYoffset

	if (isMobile) {
		tipYoffset = 146.5
	} else {
		tipYoffset = 105
	}

	if (config.indicator) {
		displayIndicator(
			scene,
			nextButton.x,
			nextButton.y - 3 * scene.scaleFactor,
			2,
			"buttonTip",
		)

		state.buttonContainer.add(scene.indicator)

		config.indicator = false
	}

	// Next button text
	const nextText = scene.add
		.text(nextButton.x, nextButton.y - 10 * scene.scaleFactor, "Next", {
			fontSize: Math.round(scene.fontSize + 2 * scene.scaleFactor) + "px",
			fill: "#fff",
			fontFamily: '"Gluten", sans-serif',
			fontWeight: "700",
			fontStyle: "bold",
			resolution: 2,
		})
		.setOrigin(0.5)
	state.buttonContainer.add(nextText)
	nextText.setVisible(false)

	// Store original positions for reset
	state.originalButtonPos = { x: nextButton.x, y: nextButton.y }
	state.originalTextPos = { x: nextText.x, y: nextText.y }

	// Handle single page case - hide back button and change next text
	if (state.totalPages <= 1) {
		backButton.setVisible(false)
		nextButton.setTexture("normalWideBtn")
		nextText.setText("LET'S GO!")
		nextButton.setPosition(nextButton.x - 30 * scene.scaleFactor, nextButton.y)

		nextText.setPosition(nextText.x, nextButton.y - 20 * scene.scaleFactor)
		nextButton.setScale(scene.scaleFactor * 0.5)
	}

	// Store references to buttons
	state.backButton = backButton
	//state.backText = backText;
	state.nextButton = nextButton
	state.nextText = nextText

	// Create page indicators
	// Adjust spacing based on number of pages
	const maxIndicatorSpace = 200 * scene.scaleFactor // Maximum width for indicators
	const baseOffset = 25 * scene.scaleFactor // Base offset for fewer pages

	// Dynamically calculate spacing based on number of pages
	let xOffset = baseOffset
	if (state.totalPages > 5) {
		// Reduce spacing for many pages to fit within maxIndicatorSpace
		xOffset = Math.min(baseOffset, maxIndicatorSpace / (state.totalPages - 1))
	}

	const startXpos =
		scene.safeZoneWidth / 2 - ((state.totalPages - 1) * xOffset) / 2

	// Create a container for indicators to manage them as a group
	state.indicatorContainer = scene.add.container(
		0,
		storyBG.y / 2 + config.indicatorYOffset * scene.scaleFactor,
	)
	state.container.add(state.indicatorContainer)

	// Create indicators if we have multiple pages and indicators are enabled
	if (state.totalPages > 1 && config.showPageIndicators) {
		for (let i = 0; i < state.totalPages; i++) {
			const indicator =
				i === 0 ? "activePageIndicator" : "inactivePageIndicator"
			const pageIndicator = scene.add
				.image(
					startXpos + i * xOffset,
					0, // Y position is relative to container
					indicator,
				)
				.setScale(0.6 * scene.scaleFactor)

			state.pageIndicators.push(pageIndicator)
			state.indicatorContainer.add(pageIndicator)
		}
	} else {
		// Hide indicators if there's only one page or indicators are disabled
		state.indicatorContainer.setVisible(false)
	}

	// Function to navigate through pages
	function navigatePage(direction) {
		const newPage = state.currentPage + direction

		// Ensure we stay within valid page range
		if (newPage >= 0 && newPage < state.totalPages) {
			showPage(newPage)
		}
	}

	// Function to show a specific page
	function showPage(pageIndex) {
		// Ensure pageIndex is within bounds
		pageIndex = Math.max(0, Math.min(pageIndex, state.totalPages - 1))

		// Update current page tracker
		state.currentPage = pageIndex

		// Update page indicators if we have more than one page
		if (state.totalPages > 1) {
			state.pageIndicators.forEach((indicator, index) => {
				indicator.setTexture(
					index === pageIndex ? "activePageIndicator" : "inactivePageIndicator",
				)
			})
		}

		// Update story content
		state.storyTitle.setText(config.titles[pageIndex] || "")
		state.storyContent.setText(config.content[pageIndex] || "")

		// Adjust content position for pages after first or when title is empty
		if (
			config.adjustContentSpace &&
			(pageIndex > 0 || !config.titles[pageIndex])
		) {
			state.storyContent.y = state.originalYPos - 30 * scene.scaleFactor
		} else {
			state.storyContent.y = state.originalYPos
		}

		// Skip navigation UI updates if we only have one page
		if (state.totalPages <= 1) return

		// Handle back button visibility
		if (pageIndex === 0) {
			state.backButton.setVisible(false)
			//state.backText.setVisible(false);
		} else {
			state.backButton.setVisible(true)
			//state.backText.setVisible(true);
		}

		// Update next button appearance based on page index
		if (pageIndex === state.totalPages - 1) {
			// Last page - use "Let's Go" button style
			state.nextButton.setTexture("normalWideBtn")
			//state.nextButton.setDisplaySize(200 * scene.scaleFactor, scaledButtonHeight * scene.scaleFactor);
			state.nextButton.setScale(scene.scaleFactor * 0.5)
			state.nextText.setText(config.finalButtonText || "LET'S GO!")

			state.nextText.setVisible(true)

			// Set absolute positions for last page
			state.nextButton.setPosition(
				state.originalButtonPos.x - 30 * scene.scaleFactor,
				state.originalButtonPos.y,
			)
			// state.nextText.setPosition(
			// 	state.originalTextPos.x - 23 * scene.scaleFactor,
			// 	state.originalButtonPos.y - 6 * scene.scaleFactor,
			// )
			state.nextText.setPosition(
				nextButton.x + 2 * scene.scaleFactor,
				nextButton.y - 5 * scene.scaleFactor,
			)
		} else {
			// Not last page - use normal "Next" button style and reset positions
			state.nextButton.setTexture("forwardButton")
			state.nextButton.setDisplaySize(scaledButtonWidth, scaledButtonHeight)
			state.nextText.setVisible(false)

			// Reset to original positions
			state.nextButton.setPosition(state.originalButtonPos.x, state.originalButtonPos.y)
			state.nextText.setPosition(state.originalTextPos.x, state.originalTextPos.y)
		}
	}

	// Function to destroy the story panel and all its components
	function destroyPanel() {
		// Make sure to remove all event listeners before destroying
		if (backButton) {
			backButton.removeAllListeners()
		}
		if (nextButton) {
			nextButton.removeAllListeners()
		}

		// Destroy the container which will destroy all children components
		if (state.container) {
			state.container.destroy()
		}

		console.log("Story panel destroyed")
	}

	// Set up button events
	backButton.on("pointerdown", () => navigatePage(-1))

	nextButton.on("pointerdown", () => {
		if (state.currentPage === state.totalPages - 1) {
			// On the last page, transition to the next scene if provided
			if (config.nextSceneKey) {
				scene.cameras.main.fadeOut(500, 0, 0, 0)
				scene.cameras.main.once("camerafadeoutcomplete", () => {
					scene.scene.start(config.nextSceneKey)
				})
			} else if (config.missionOutro) {
				scene.missionPanelController()
			} else {
				console.log("No Scene - destroying panel")
				scene.setupNormalMode02()
				// Destroy the panel since no next scene is specified
				destroyPanel()
			}

			// Call onComplete callback if provided
			if (config.onComplete && typeof config.onComplete === "function") {
				config.onComplete()
			}
		} else {
			// Otherwise, go to the next page
			navigatePage(1)
			destroyIndicator(scene)
		}
	})

	// Show the first page
	showPage(0)

	// Return public methods
	return {
		container: state.container,
		navigateTo: showPage,
		next: () => navigatePage(1),
		back: () => navigatePage(-1),
		getCurrentPage: () => state.currentPage,
		getTotalPages: () => state.totalPages,
		destroy: destroyPanel, // Expose the destroy method
	}
}

// export function displayInstructions(
// 	scene,
// 	instructionsText,
// 	fontSize,
// 	width = 600,
// 	height = 80,
// ) {
// 	const instructionBgX = scene.safeZoneX + scene.safeZoneWidth / 2
// 	const instructionBgY = 8 * scene.scaleFactor


// 	if (scene.instructionBg) {
// 		scene.instructionBg.destroy()
// 	}
// 	if (scene.instructionText) {
// 		scene.instructionText.destroy()
// 	}
// 	//instructionsBar
// 	// scene.instructionBg = scene.add.image(instructionBgX, instructionBgY, 'longContainer')
// 	//     .setOrigin(0.5)
// 	//     .setScale(0.4 * scene.scaleFactor)
// 	//     .setDepth(2);

// 	//const sliceValue = 10 * scene.scaleFactor / (window.devicePixelRatio || 1);
// 	const sliceValue = 50
// 	//const sliceValue =  (window.devicePixelRatio || 1)

// 	console.log("Slice Valiue" + sliceValue)

// 	scene.instructionBg = scene.add
// 		.nineslice(
// 			instructionBgX,
// 			instructionBgY,
// 			"instrBar",
// 			0,
// 			width * scene.scaleFactor,
// 			height * scene.scaleFactor,
// 			sliceValue,
// 			sliceValue,
// 			sliceValue,
// 			sliceValue,
// 		)
// 		.setOrigin(0.5, 0)

// 	const instructionTextY = instructionBgY + scene.instructionBg.height * 0.4
// 	//scene.add.existing(instructionBg);
// 	scene.instructionText = scene.add
// 		.text(instructionBgX, instructionTextY, instructionsText, {
// 			fontSize: Math.round(fontSize * scene.scaleFactor) + "px",
// 			fill: "#11044E",
// 			align: "center",
// 			fontFamily: '"Space Grotesk", sans-serif',
// 			fontStyle: "bold",
// 			fontWeight: "700",
// 			resolution: 2,
// 		})
// 		.setOrigin(0.5)
// 		.setDepth(2)

// 	animateElements([scene.instructionBg, scene.instructionText], scene)
// }

export function displayInstructions(
	scene,
	instructionsText,
	fontSize,
	width = 600,
	height = 80,
	cornerWidth = 30
) {
	const instructionBgX = scene.safeZoneX + scene.safeZoneWidth / 2
	const instructionBgY = 8 * scene.scaleFactor

	// Clean up old elements
	if (scene.instructionBgContainer) scene.instructionBgContainer.destroy()
	if (scene.instructionText) scene.instructionText.destroy()

	const scaledWidth = width * scene.scaleFactor
	const scaledHeight = height * scene.scaleFactor

	// Create left edge first to get its width
	const leftEdge = scene.add
		.image(0, 0, 'left-edge')
		.setOrigin(1, 0)
		.setDisplaySize(scene.scaleFactor * cornerWidth, scaledHeight)

	// Create right edge to get its width
	const rightEdge = scene.add
		.image(0, 0, 'right-edge')
		.setOrigin(0, 0)
		.setDisplaySize(scene.scaleFactor * cornerWidth, scaledHeight)

	// Calculate center width (total width minus the edge widths)
	const leftWidth = leftEdge.displayWidth
	const rightWidth = rightEdge.displayWidth
	const centerWidth = scaledWidth - leftWidth - rightWidth

	// Create center piece stretched to fill the gap (add 2 pixels overlap)
	const centerPiece = scene.add
		.image(0, 0, 'centre')
		.setOrigin(0.5, 0)
		.setDisplaySize(centerWidth + 2, scaledHeight)

	// Position pieces relative to center (0, 0)
	leftEdge.setX(Math.round(-centerWidth / 2))
	rightEdge.setX(Math.round(centerWidth / 2))

	// Create container and add all pieces
	scene.instructionBgContainer = scene.add.container(instructionBgX, instructionBgY, [
		centerPiece,  // Add center first (behind)
		leftEdge,
		rightEdge
	])
	//.setDepth(2)

	const instructionTextY = instructionBgY + scaledHeight * 0.4

	scene.instructionText = scene.add
		.text(instructionBgX, instructionTextY, instructionsText, {
			fontSize: Math.round(fontSize * scene.scaleFactor) + "px",
			fill: "#11044E",
			align: "center",
			fontFamily: '"Space Grotesk", sans-serif',
			fontStyle: "bold",
			fontWeight: "700",
			resolution: 2,
		})
		.setOrigin(0.5)
	//	.setDepth(3)

	animateElements([
		scene.instructionBgContainer,
		scene.instructionText
	], scene)
}

export function destroyInstructions(scene) {
	if (scene.instructionBgContainer) scene.instructionBgContainer.destroy()
	if (scene.instructionText) scene.instructionText.destroy()
}

export function displayIndicator(scene, xPos, yPos, scale, type) {
	// console.log("Indicator Displayed")

	// // Destroy existing indicator if it exists
	// if (scene.indicator) {
	// 	scene.indicator.destroy()
	// }

	// // Create new indicator
	// scene.indicator = scene.add
	// 	.image(xPos, yPos, type)
	// 	.setOrigin(0.5)
	// 	.setDepth(80)
	// 	.setScale((scene.scaleFactor * 0.5) * scale)
	// scene.indicator.name = "indicator"

	// // Make the indicator pulse
	// const pulseTween = scene.add.tween({
	// 	targets: scene.indicator,
	// 	duration: 800,
	// 	ease: Phaser.Math.Easing.Sine.InOut,
	// 	scale: scene.indicator.scale + 0.05 * scene.scaleFactor,
	// 	yoyo: true,
	// 	repeat: -1,
	// })
}

export function destroyIndicator(scene) {
	if (scene.indicator) {
		scene.indicator.destroy()
	}
}

export function displayTooltip(scene, options) {
	const {
		xPos,
		yPos,
		type,
		scale = 1,
		text = "",
		fontScale = 0,
		xTextOffset = 0,
		yTextOffset = 0,
		wrapWidth = 1.01,
		images = {},
		textColor = "#11044E"
	} = options

	const addTooltip = () => {
		scene.tooltip = scene.add
			.image(xPos, yPos, type)
			.setOrigin(0.5)
			.setDepth(2)
			.setScale(scene.scaleFactor * 0.5 * scale)

		scene.tooltip.name = "tooltip"

		// 1. Create with EMPTY string first
		scene.tooltipText = scene.add
			.rexBBCodeText(
				scene.tooltip.x + xTextOffset,
				scene.tooltip.y + yTextOffset,
				"",   // <-- empty!
				{
					fontSize: Math.round(scene.fontSize + fontScale * scene.scaleFactor) + "px",
					color: textColor,
					align: "center",
					fontFamily: '"Space Grotesk", sans-serif',
					fontWeight: "700",
					resolution: 2,
					wrap: {
						mode: "word",
						width: scene.tooltip.width * wrapWidth * scene.scaleFactor,
					},
				},
			)
			.setOrigin(0.5)
			.setDepth(2)

		// 2. Register images BEFORE setting text
		Object.entries(images).forEach(([imgKey, imgConfig]) => {
			scene.tooltipText.addImage(imgKey, imgConfig)
		})

		// 3. NOW set the text — images are already known
		scene.tooltipText.setText(text)
	}

	if (scene.tooltip) {
		scene.tooltip.destroy()
		scene.tooltipText?.destroy()
	}

	addTooltip()
}

export function displayTooltip02(scene, options) {
	// Default values for options
	const {
		xPos,
		yPos,
		type,
		scale = 1,
		text = "",
		fontScale = 0,
		xTextOffset = 0,
		yTextOffset = 0,
		wrapWidth = 1.01,
	} = options

	if (scene.tooltip02) {
		scene.tooltip02.destroy()
		if (scene.tooltipTex02) {
			scene.tooltipText02.destroy()
		}

		// Create new tooltip
		scene.tooltip02 = scene.add
			.image(xPos, yPos, type)
			.setOrigin(0.5)
			.setDepth(2)
			.setScale((scene.scaleFactor * 0.5) * scale)

		scene.tooltip02.name = "tooltip02"

		scene.tooltipText02 = scene.add
			.rexBBCodeText(
				scene.tooltip02.x + xTextOffset,
				scene.tooltip02.y + yTextOffset,
				text,
				{
					fontSize:
						Math.round(scene.fontSize + fontScale * scene.scaleFactor) + "px",
					color: "#11044E",
					align: "center",
					fontFamily: '"Space Grotesk", sans-serif',
					resolution: 2,
					wrap: {
						mode: "word",
						width: scene.tooltip02.width * wrapWidth * scene.scaleFactor,
					},
				},
			)
			.setOrigin(0.5)
			.setDepth(2)
	} else {
		scene.tooltip02 = scene.add
			.image(xPos, yPos, type)
			.setOrigin(0.5)
			.setDepth(2)
			.setScale((scene.scaleFactor * 0.5) * scale)

		scene.tooltipText02 = scene.add
			.rexBBCodeText(
				scene.tooltip02.x + xTextOffset,
				scene.tooltip02.y + yTextOffset,
				text,
				{
					fontSize:
						Math.round(scene.fontSize + fontScale * scene.scaleFactor) + "px",
					color: "#11044E",
					align: "center",
					fontFamily: '"Space Grotesk", sans-serif',
					resolution: 2,
					wrap: {
						mode: "word",
						width: scene.tooltip02.width * wrapWidth * scene.scaleFactor,
					},
				},
			)
			.setOrigin(0.5)
			.setDepth(2)
	}
}

export function destroyTooltip02(scene) {
	console.log("Destroying tooltip")
	if (scene.tooltip02) {
		scene.tooltip02.destroy()
		scene.tooltipText02.destroy()
	}
}

export function destroyTooltip(scene) {
	console.log("Destroying tooltip")
	if (scene.tooltip) {
		scene.tooltip.destroy()
		scene.tooltipText.destroy()
	}
}

export function createTopBar(scene) {
	if (scene.tabletBar) {
		scene.tabletBar.destroy()
	}
	if (scene.battery) {
		scene.battery.destroy()
	}
	if (scene.wifiOn) {
		scene.wifiOn.destroy()
	}
	if (scene.signal) {
		scene.signal.destroy()
	}
	if (scene.bluetooth) {
		scene.bluetooth.destroy()
	}
	if (scene.timeText) {
		scene.timeText.destroy()
	}
	if (scene.dateText) {
		scene.dateText.destroy()
	}

	scene.tabletScene = scene.scene.get("TabletScene")
	scene.tabletBar = scene.add
		.image(
			scene.tabletScene.sceneW / 2,
			scene.tabletScene.tabletView.y - 155 * scene.scaleFactor,
			"tabletStatusBar",
		)
		.setOrigin(0.5)
		.setScale(scene.tabletScene.scaleFactor)
		.setDepth(60)

	//left side items
	scene.battery = scene.add
		.image(
			scene.tabletBar.x + 210 * scene.tabletScene.scaleFactor,
			scene.tabletBar.y,
			"battery",
		)
		.setOrigin(0.5)
		.setScale(scene.tabletScene.scaleFactor / 2)
		.setDepth(60)

	scene.wifiOn = scene.add
		.image(
			scene.battery.x - 40 * scene.tabletScene.scaleFactor,
			scene.tabletBar.y,
			"wifiOn",
		)
		.setOrigin(0.5)
		.setScale(scene.tabletScene.scaleFactor / 2)
		.setDepth(60)

	scene.signal = scene.add
		.image(
			scene.wifiOn.x - 30 * scene.tabletScene.scaleFactor,
			scene.tabletBar.y,
			"signal",
		)
		.setOrigin(0.5)
		.setScale(scene.tabletScene.scaleFactor / 2)
		.setDepth(60)

	scene.bluetooth = scene.add
		.image(
			scene.signal.x - 30 * scene.tabletScene.scaleFactor,
			scene.tabletBar.y,
			"bluetooth",
		)
		.setOrigin(0.5)
		.setScale(scene.tabletScene.scaleFactor / 2)
		.setDepth(60)

	let date = new Date()
	let hours = date.getHours()
	let minutes =
		date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()
	let ampm = hours >= 12 ? "PM" : "AM"
	hours = hours % 12
	hours = hours ? hours : 12 // the hour '0' should be '12'
	hours = hours < 10 ? "0" + hours : hours
	let systemTime = `${hours}:${minutes} ${ampm}`

	let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate()
	let dayName = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][date.getDay()]
	let monthName = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec",
	][date.getMonth()]
	let year = date.getFullYear()
	let systemDate = `${dayName} ${day} ${monthName} ${year}`

	//right side items
	scene.timeText = scene.add
		.text(
			scene.tabletBar.x - 240 * scene.scaleFactor,
			scene.tabletBar.y - 5 * scene.scaleFactor,
			systemTime,
			{
				fontFamily: "Gluten",
				fontSize:
					scene.tabletScene.fontSize - 6 * scene.tabletScene.scaleFactor,
				color: "#11044E",
				align: "center",
				resolution: 2,
			},
		)
		.setDepth(60)

	scene.dateText = scene.add
		.text(
			scene.timeText.x + 70 * scene.scaleFactor,
			scene.tabletBar.y - 5 * scene.scaleFactor,
			systemDate,
			{
				fontFamily: "Gluten",
				fontSize:
					scene.tabletScene.fontSize - 6 * scene.tabletScene.scaleFactor,
				color: "#11044E",
				align: "center",
				resolution: 2,
			},
		)
		.setDepth(60)
}

export function playUISound(scene, soundManager, sound, volume, loop = false) {
	soundManager.playEffect(sound, {
		volume: volume,
		category: "ui",
		loop: loop,
	})
}

export function displayTutorialHand(scene, options) {
	const {
		xPos,
		yPos,
		rotation,
	} = options

	if (scene.tutorialHand) {
		scene.tutorialHand.destroy()
	}

	const rotationInRadians = Phaser.Math.DegToRad(rotation)

	scene.tutorialHand = scene.add
		.image(xPos, yPos, 'hand')
		.setOrigin(0.5)
		.setDepth(14)
		.setScale(scene.scaleFactor * 0.48)
		.setRotation(rotationInRadians)

	const distance = 30 // movement distance
	const offsetX = Math.cos(rotationInRadians - Math.PI / 2) * distance
	const offsetY = Math.sin(rotationInRadians - Math.PI / 2) * distance

	//back-and-forth animation in local space
	scene.tweens.add({
		targets: scene.tutorialHand,
		x: xPos + offsetX,
		y: yPos + offsetY,
		duration: 800, // Time for one direction
		ease: 'Sine.easeInOut',
		yoyo: true,
		repeat: -1
	})
}

export function destroyTutorialHand(scene) {
	if (scene.tutorialHand) {
		scene.tutorialHand.destroy()
	}
}

export function animateElements(objects, scene) {
	const objectArray = Array.isArray(objects) ? objects : [objects];

	objectArray.forEach((obj, index) => {
		// Check if this is a group of objects (nested array)
		const targets = Array.isArray(obj) ? obj : [obj];

		targets.forEach((target) => {
			if (target && scene) {
				// Store original scale
				const originalScaleX = target.scaleX;
				const originalScaleY = target.scaleY;

				// Immediately set scale to 0
				target.setScale(0);

				// Tween back to original scale with bounce
				scene.tweens.add({
					targets: target,
					scaleX: originalScaleX,
					scaleY: originalScaleY,
					duration: 350,
					ease: 'Back.easeOut',
					delay: 250 + (index * 175), // Stagger delay based on outer index
					yoyo: false,
					repeat: 0
				});
			}
		});
	});
}

export function playTabletUnlockAnimations(scene, options) {
	const defaults = {
		xPos: 100,
		yPos: 100,
		delayTime: 1000
	}

	const config = { ...defaults, ...options }

	if (!scene.anims.exists('unlockAnim')) {
		scene.anims.create({
			key: 'unlockAnim',
			frames: scene.anims.generateFrameNames('appUnlock', {
				prefix: 'appUnlock_',
				start: 1,
				end: 78,
				zeroPad: 3,
				suffix: '.png'
			}),
			frameRate: 30,
			repeat: 0
		});
	}

	scene.unlockSprite = scene.add.sprite(
		config.xPos,
		config.yPos,
		'appUnlock');

	scene.unlockSprite.setScale(scene.scaleFactor)

	scene.time.delayedCall(config.delayTime, () => {
		if (scene.unlockSprite && scene.unlockSprite.active) {
			scene.unlockSprite.play('unlockAnim');
		}
	});

	scene.unlockSprite.on('animationcomplete', () => {
		console.log('Animation finished!');
		scene.unlockSprite.destroy();
	});
}

export function playNotificationAnimation(scene, options) {
	const defaults = {
		xPos: 100,
		yPos: 100,
		delayTime: 500
	}

	const config = { ...defaults, ...options }

	if (!scene.anims.exists('notifPop')) {
		scene.anims.create({
			key: 'notifPop',
			frames: scene.anims.generateFrameNames('pipPopUp', {
				prefix: 'pipPop_',
				start: 1,
				end: 17,
				zeroPad: 3,
				suffix: '.png'
			}),
			frameRate: 30,
			repeat: 0
		});
	}

	console.log("Notif anim added to scene:", scene.scene?.key || scene.sys?.config?.key || "unknown")

	// Remove existing notification bell if present
	if (scene.notificationBell) {
		console.log("Removing existing notif bell")
		scene.notificationBell.destroy()
		scene.notificationBell = null
	}

	scene.notificationBell = scene.add
		.sprite(
			config.xPos,
			config.yPos,
			"pipPopUp",
			"pipPop_001.png" // Changed from 000 to 001
		)
		.setOrigin(0.5)
		.setScale(scene.scaleFactor * 1.1 * 0.5)

	// Store the timer reference so we can cancel it if needed
	scene.notificationTimer = scene.time.delayedCall(config.delayTime, () => {
		// Check if the sprite still exists before playing
		if (scene.notificationBell && scene.notificationBell.active) {
			scene.notificationBell.play('notifPop');
		}
	});

	scene.notificationBell.on('animationcomplete', () => {
		console.log('Animation finished!');
		scene.notificationTimer.remove()
		scene.notificationTimer = null
		// scene.notificationBell.destroy();
	});
}

export function removeNotificationBell(scene) {
	console.log("Removing notif bell")

	// Cancel any pending timer
	// if (scene.notificationTimer) {
	// 	scene.notificationTimer.remove()

	// }

	//scene.notificationTimer = null

	// if (scene.notificationBell) {
	// 	scene.notificationBell.destroy()		
	// }

	// scene.notificationBell = null
}

export function playTickAnimation(scene, options) {
	const defaults = {
		xPos: scene.gameW / 2,
		yPos: scene.gameH / 2,
		delayTime: 500
	}

	const config = { ...defaults, ...options }

	if (!scene.anims.exists('tickAnim')) {
		scene.anims.create({
			key: 'tickAnim',
			frames: scene.anims.generateFrameNames('tickJuice', {  // ✓ Changed from 'Tick'
				prefix: 'Tick_',
				start: 1,
				end: 42,
				zeroPad: 3,
				suffix: '.png'
			}),
			frameRate: 30,
			repeat: 0
		})
	}

	if (scene.tickAnim) {
		scene.tickAnim.destroy()
	}

	scene.tickAnim = scene.add
		.sprite(
			config.xPos,
			config.yPos,
			'tickJuice',
			'Tick_001.png'
		).setOrigin(0.5)
		.setScale(scene.scaleFactor * 0.5)
		.setDepth(50000)

	scene.tickAnimTimer = scene.time.delayedCall(config.delayTime, () => {
		// Check if the sprite still exists before playing
		if (scene.tickAnim && scene.tickAnim.active) {
			scene.tickAnim.play('tickAnim');
		}
	});

	scene.tickAnim.on('animationcomplete', () => {
		console.log('Animation finished!');
		scene.tickAnimTimer.remove()
		scene.tickAnimTimer = null

		scene.time.delayedCall(1000, () => {
			if (scene.tickAnim) {
				scene.tickAnim.destroy()
			}
		})


	});
}

export function playErrorAnimation(scene, options = {}) {
	const {
		shakeDistance = 8,      // pixels to shake
		shakeDuration = 40,     // duration per shake
		shakeRepeats = 4,       // number of shakes
		includeTablet = true,
		flashColor = 0xffffff,
		flashDuration = 200,
		flashAlpha = 0.9,
		onComplete = null
	} = options;

	const scenesToShake = [];

	// Add the current program scene
	scenesToShake.push(scene);

	// Optionally add the tablet scene
	if (includeTablet) {
		const tabletScene = scene.scene.get('TabletScene');
		if (tabletScene) {
			scenesToShake.push(tabletScene);
		}
	}

	// Track completion if callback provided
	let completedTweens = 0;
	const totalScenes = scenesToShake.length;

	// Shake and flash all scenes
	scenesToShake.forEach(sceneToShake => {
		const camera = sceneToShake.cameras.main;
		const startX = camera.scrollX;

		// Create damping effect by reducing distance on each repeat
		let currentRepeat = 0;

		sceneToShake.tweens.add({
			targets: camera,
			scrollX: startX + shakeDistance,
			duration: shakeDuration,
			yoyo: true,
			repeat: shakeRepeats,
			ease: 'Sine.easeInOut',
			onRepeat: () => {
				currentRepeat++;
				// Reduce shake distance each time (damping)
				const dampingFactor = 1 - (currentRepeat / (shakeRepeats + 1));
				const newDistance = startX + (shakeDistance * dampingFactor);
				sceneToShake.tweens.add({
					targets: camera,
					scrollX: newDistance,
					duration: shakeDuration,
					yoyo: true,
					ease: 'Sine.easeInOut'
				});
			},
			onComplete: () => {
				// Ensure camera returns to original position
				camera.scrollX = startX;

				completedTweens++;
				if (completedTweens === totalScenes && onComplete) {
					onComplete();
				}
			}
		});

		//const tabletScene = scene.scene.get('TabletScene');
		//Red flash overlay
		const flashRect = scene.add.rectangle(
			camera.worldView.centerX,
			camera.worldView.centerY,
			camera.width,
			camera.height,
			flashColor,
			flashAlpha
		).setScrollFactor(0).setDepth(10000);

		// Fade out and destroy
		scene.tweens.add({
			targets: flashRect,
			alpha: 0,
			duration: flashDuration,
			ease: 'Cubic.easeOut',
			onComplete: () => {
				flashRect.destroy();
			}
		});
	});
}

export function playConfettiAnimation(scene, options = {}) {
	const {
		x = scene.cameras.main.centerX,
		y = scene.cameras.main.centerY,
		speed = 900,
		angle = -90, // upward
		cone = 50, // spread angle
		velocap = 800,
		particleCount = 150,
		particleTexture = 'particleTexture',
		confettiSize = 8,
		colors = [0xFFFAE6, 0xCD0172, 0xFF66B9, 0x7FF9FF, 0x5C58EB, 0x00B0CB]
	} = options;

	// Create particle texture if it doesn't exist
	if (!scene.textures.exists(particleTexture)) {
		const texture = scene.textures.createCanvas(particleTexture, 10, 10);
		const context = texture.getContext();
		context.fillStyle = '#ffffff';
		context.fillRect(0, 0, confettiSize, confettiSize);
		texture.refresh();
	}

	// Get actual camera/screen dimensions
	const leftX = scene.cameras.main.scrollX;
	const rightX = scene.cameras.main.scrollX + scene.cameras.main.width;
	const emitY = y;

	const baseConfig = {
		speed: { min: speed, max: speed * 1.2 },
		lifespan: { min: 500, max: 1200 },
		scaleX: {
			onUpdate: (particle, key, t) => {
				return Math.sin((t / 1) * Math.PI * 3);
			},
		},
		rotate: { min: -180, max: 180 },
		tint: colors,
		emitting: false,
		gravityY: 1000,
		maxVelocityX: { start: velocap, end: 50, ease: 'Sine.easeOut' },
		maxVelocityY: { start: velocap, end: 50, ease: 'Sine.easeOut' },
	};

	// Left corner emitter (shooting up)
	const leftEmitter = scene.add.particles(0, 0, particleTexture, {
		...baseConfig,
		angle: { min: -90 - cone, max: -90 + cone },
	});
	leftEmitter.setDepth(100000000);
	leftEmitter.explode(particleCount, leftX, scene.gameH);

	// Right corner emitter (shooting up)
	const rightEmitter = scene.add.particles(0, 0, particleTexture, {
		...baseConfig,
		angle: { min: -90 - cone, max: -90 + cone },
	});
	rightEmitter.setDepth(100000000);
	rightEmitter.explode(particleCount, rightX, scene.gameH);

	// Clean up emitters after particles are done
	scene.time.delayedCall(1500, () => {
		leftEmitter.destroy();
		rightEmitter.destroy();
	});
}

export function playFireworksAnimation(scene, options = {}) {
	const {
		x = scene.cameras.main.centerX,
		y = scene.cameras.main.centerY,
		width = 400,
		height = 300,
		particleCount = 100,
		particleTexture1 = 'particle1',
		particleTexture2 = 'particle2',
		colors = [0xFFFAE6, 0xCD0172, 0xFF66B9, 0x7FF9FF, 0x5C58EB, 0x00B0CB],
		duration = 2000,
		speed = { min: 20, max: 300 },
		lifespan = 600,
		gravityY = 200,
		frequency = 100,
		depth = 9,
	} = options;

	// Create particle textures if they don't exist
	[particleTexture1, particleTexture2].forEach((textureName, index) => {
		if (!scene.textures.exists(textureName)) {
			const size = index === 0 ? 8 * scene.scaleFactor : 6 * scene.scaleFactor;
			const texture = scene.textures.createCanvas(textureName, size, size);
			const context = texture.getContext();
			context.fillStyle = '#ffffff';
			context.beginPath();
			context.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
			context.fill();
			texture.refresh();
		}
	});

	const halfW = width / 2 + 1 * scene.scaleFactor;
	const halfH = height / 2 + 1 * scene.scaleFactor;

	const p0 = new Phaser.Math.Vector2(x - halfW + 5, y + halfH - 5);
	const p1 = new Phaser.Math.Vector2(x, y - height - 50);
	const p2 = new Phaser.Math.Vector2(x + halfW - 5, y + halfH - 5);
	const curve = new Phaser.Curves.QuadraticBezier(p0, p1, p2);
	const points = curve.getSpacedPoints(particleCount);
	const tempVec = new Phaser.Math.Vector2();
	const emittersArray = [];

	points.forEach((p, i) => {
		const tangent = curve.getTangent(i / points.length);
		tempVec.copy(tangent).normalizeRightHand().scale(-32).add(p);
		const angle = Phaser.Math.RadToDeg(Phaser.Math.Angle.BetweenPoints(p, tempVec));
		const texture = (i % 2 === 0) ? particleTexture1 : particleTexture2;

		const emitter = scene.add.particles(p.x, p.y, texture, {
			speed: speed,
			scale: { start: 1 * scene.scaleFactor, end: 0.1 * scene.scaleFactor },
			maxVelocityX: { start: 2000, end: 50, ease: 'Sine.easeOut' },
			maxVelocityY: { start: 2000, end: 50, ease: 'Sine.easeOut' },
			opacity: { values: [100, 100, 100, 0], interpolation: 'catmull', ease: 'linear' },
			rotate: { min: 0, max: 360, random: true },
			angle: angle,
			gravityY: gravityY,
			lifespan: lifespan,
			blendMode: 'screen',
			frequency: frequency,
			//tint: colors,
			emitting: false,
		});

		emitter.setDepth(depth);
		emittersArray.push(emitter);
	});

	// Store emitters on the scene for later cleanup
	if (!scene.fireworksEmitters) {
		scene.fireworksEmitters = [];
	}
	scene.fireworksEmitters.push(...emittersArray);

	emittersArray.forEach(emitter => emitter.start());

	if (duration && duration !== Infinity) {
		scene.time.delayedCall(duration, () => {
			emittersArray.forEach(emitter => {
				emitter.stop();
				emitter.destroy();
				// Remove from scene's tracking array
				const index = scene.fireworksEmitters.indexOf(emitter);
				if (index > -1) {
					scene.fireworksEmitters.splice(index, 1);
				}
			});
		});
	}

	return emittersArray;
}

export function destroyFireworksAnimation(scene) {
	if (scene.fireworksEmitters && scene.fireworksEmitters.length > 0) {
		scene.fireworksEmitters.forEach(emitter => {
			if (emitter && !emitter.scene) return; // Already destroyed
			emitter.stop();
			emitter.destroy();
		});
		scene.fireworksEmitters = [];
	}
}

export function playExplosionAnimation(scene, options = {}) {
	const {
		x = scene.cameras.main.centerX,
		y = scene.cameras.main.centerY,
		particleTexture1 = 'particle1',
		particleTexture2 = 'particle2',
		particleCount = 8,
		lifespan = 850,
		speed = { min: 150, max: 250 },
		scale = { start: 1.15 * scene.scaleFactor, end: 0 },
		gravityY = 0,
		blendMode = 'normal',
		colors = [0xFFFAE6, 0xCD0172, 0xFF66B9, 0x7FF9FF, 0x5C58EB, 0x00B0CB],
		depth = 1000000000,
	} = options;

	const particleConfig = {
		lifespan: lifespan,
		speed: speed,
		scale: scale,
		gravityY: gravityY,
		blendMode: blendMode,
		emitting: false,
		maxVelocityX: { start: 1000, end: 50, ease: 'Sine.easeOut' },
		maxVelocityY: { start: 1000, end: 50, ease: 'Sine.easeOut' },
		//tint: colors,
	};

	const emitter1 = scene.add.particles(x, y, particleTexture1, particleConfig);
	const emitter2 = scene.add.particles(x, y, particleTexture2, particleConfig);

	emitter1.setDepth(depth);
	emitter2.setDepth(depth);

	// Store emitters on the scene for later cleanup
	if (!scene.explosionEmitters) {
		scene.explosionEmitters = [];
	}
	scene.explosionEmitters.push(emitter1, emitter2);

	// Fire the explosion
	emitter1.explode(particleCount);
	emitter2.explode(particleCount);

	// Clean up emitters after particles die
	scene.time.delayedCall(lifespan + 100, () => {
		emitter1.destroy();
		emitter2.destroy();

		// Remove from scene's tracking array
		const index1 = scene.explosionEmitters.indexOf(emitter1);
		if (index1 > -1) {
			scene.explosionEmitters.splice(index1, 1);
		}
		const index2 = scene.explosionEmitters.indexOf(emitter2);
		if (index2 > -1) {
			scene.explosionEmitters.splice(index2, 1);
		}
	});

	return [emitter1, emitter2];
}

export function destroyExplosionAnimation(scene) {
	if (scene.explosionEmitters && scene.explosionEmitters.length > 0) {
		scene.explosionEmitters.forEach(emitter => {
			if (emitter && !emitter.scene) return; // Already destroyed
			emitter.stop();
			emitter.destroy();
		});
		scene.explosionEmitters = [];
	}
}

export function playUnlockPlanetAnimation(scene, options) {
	const defaults = {
		xPos: scene.gameW / 2,
		yPos: scene.gameH / 2,
		delay: 500
	}

	const config = { ...defaults, ...options }

	if (!scene.anims.exists('planetUnlockAnim')) {
		scene.anims.create({
			key: 'planetUnlockAnim',
			frames: scene.anims.generateFrameNames('planetUnlock', {
				prefix: 'Planet unlock_',
				start: 1,
				end: 69,
				zeroPad: 3,
				suffix: '.png'
			}),
			frameRate: 30,
			repeat: 0
		})
	}

	if (scene.planetUnlockSprite) {
		scene.planetUnlockSprite.destroy()
	}

	scene.planetUnlockSprite = scene.add.sprite(
		config.xPos,
		config.yPos,
		'planetUnlock',
		'Planet unlock_001.png'
	).setOrigin(0.5)
		.setScale(scene.scaleFactor)
		.setDepth(5000000)

	scene.planetUnlockTimer = scene.time.delayedCall(config.delay, () => {
		// Check if the sprite still exists before playing
		if (scene.planetUnlockSprite && scene.planetUnlockSprite.active) {
			scene.planetUnlockSprite.play('planetUnlockAnim');
		}
	});

	scene.planetUnlockSprite.on('animationcomplete', () => {
		console.log('Planet Unlock Animation finished!');
		scene.planetUnlockTimer.remove()
		scene.planetUnlockTimer = null

		scene.time.delayedCall(1000, () => {
			if (scene.planetUnlockSprite) {
				scene.planetUnlockSprite.destroy()
				////////////////////////////
				if (!Array.isArray(scene.planetsUnlockAnimationShown)) {
					scene.planetsUnlockAnimationShown = []
				}

				// Add to local array (check prevents duplicates)
				if (!scene.planetsUnlockAnimationShown.includes(scene.planetIndex)) {
					scene.planetsUnlockAnimationShown.push(scene.planetIndex)
				}

				// Update saved data
				const savedData = checkLocalSavedData()
				if (savedData) {
					// Ensure the saved data also has the array initialized
					if (!Array.isArray(savedData.planetsUnlockAnimationShown)) {
						savedData.planetsUnlockAnimationShown = []
					}
					savedData.planetsUnlockAnimationShown = scene.planetsUnlockAnimationShown
					localStorage.setItem("userData", JSON.stringify(savedData))
					console.log(`Planet ${scene.planetIndex} unlock animation marked as shown`)
				}
			}
		})
	});

}
export function handleGameProgressUpdate(cockpitScene) {
	// Get user data from localStorage
	const userData = JSON.parse(localStorage.getItem("userData")) || {}
	const currentPlanet = userData?.currentPlanet || 0
	const savedMiniLevel = userData?.userMiniLevel || 0
	let alertsOpened = userData?.alertsOpened || {}
	let emailsOpened = userData?.emailsOpened || 0

	// Return early if not on a valid planet
	if (currentPlanet < 1) return

	// Common task handling functions
	const setupScanComplete = () => {
		cockpitScene.LScanButton.setVisible(false)
		cockpitScene.LScanText.setVisible(false)
		cockpitScene.taskHeaderText.setVisible(true)
		cockpitScene.taskHeaderText.setText("???")
		cockpitScene.LTaskGrid.setVisible(true)

		// displayInstructions(
		// 	cockpitScene,
		// 	"Scan complete! Results can be found on your tablet.",
		// 	12,
		// 	400,
		// 	60,
		// )
		// cockpitScene.tweens.add({
		// 	targets: cockpitScene.tabletNotification,
		// 	scale: cockpitScene.tabletNotifScale / 2,
		// 	ease: "Back.Out",
		// 	duration: 100,
		// })
		cockpitScene.tabletButton.input.enabled = true
		// cockpitScene.tabletNotification.setVisible(true)
		playNotificationAnimation(cockpitScene, {
			xPos: cockpitScene.tabletButton.x + 40 * cockpitScene.scaleFactor,
			yPos: cockpitScene.tabletButton.y - 40 * cockpitScene.scaleFactor
		})

		displayTutorialHand(cockpitScene, {
			xPos: cockpitScene.tabletButton.x + 100 * cockpitScene.scaleFactor,
			yPos: cockpitScene.tabletButton.y - 100 * cockpitScene.scaleFactor,
			rotation: -135,
		})
		if (cockpitScene.currentPlanet === 3) {
			destroyInstructions(cockpitScene)
			if (cockpitScene.tutorialHand) {
				cockpitScene.tutorialHand.destroy()
			}
		}
		cockpitScene.tabletButton.setAlpha(1)
	}

	const setupIDComplete = (taskActive = "left") => {
		// displayInstructions(
		// 	cockpitScene,
		// 	"Well done! You’ve completed the ID task.\n‘Assess’ the creature’s diet using the Field Guide app on the tablet.",
		// 	12,
		// 	450,
		// 	60,
		// )
		updateMiniLevel(savedMiniLevel)
		cockpitScene.changeTaskTexture(1, "taskActive", taskActive)
		cockpitScene.leftScaleUpButton.input.enabled = false
		cockpitScene.leftScaleUpButton.setAlpha(0.5)
	}

	const setupFeedTask = (foodName, side = "left") => {
		const sidePrefixes = {
			left: "L",
			right: "R",
		}
		const prefix = sidePrefixes[side]

		cockpitScene.changeTaskTexture(2, "taskActive", side)
		cockpitScene[`${prefix}FeedMeButton`].setVisible(true)
		cockpitScene[`${prefix}FeedMeText`].setVisible(true)

		if (side === "left") {
			cockpitScene.taskHeaderText.setText(foodName)
		} else {
			cockpitScene.RTaskHeaderText.setText(foodName)
		}

		if (currentPlanet === 3 && savedMiniLevel === 16) {
			if (side === "left") {
				cockpitScene.foodLabel.setText("creatureName")
			}
		}

		displayInstructions(
			cockpitScene,
			"Press the ‘FEED ME' button to start.",
			12,
			250,
			60,
		)
		destroyTooltip(cockpitScene)
		cockpitScene.taskHeaderText.setVisible(true)
		//cockpitScene.taskHeaderText.setText("Emberfruit")
		//cockpitScene.tabletButton.setVisible(false)
		//cockpitScene.tabletNotification.setVisible(false)
		removeNotificationBell(cockpitScene)

		cockpitScene.showAllFoodTaskGridsFeeding(prefix)
	}

	const setupDischargeTask = (creatureName, side = "left") => {
		const sidePrefixes = {
			left: "L",
			right: "R",
		}
		const prefix = sidePrefixes[side]

		updateMiniLevel(savedMiniLevel)
		cockpitScene.changeTaskTexture(4, "taskActive", side)
		//cockpitScene.tabletNotification.setVisible(false)
		removeNotificationBell(cockpitScene)

		displayInstructions(
			cockpitScene,
			`All tasks complete! Press ‘DISCHARGE' to let the creature go!`,
			12,
			400,
			60,
		)
		// if (creatureName === "Cloudstrider") {
		// 	displayInstructions(
		// 		cockpitScene,
		// 		`All Tasks Complete! This ${creatureName} is ready to return to their planet pals!`,
		// 		12,
		// 		500,
		// 		60,
		// 	)
		// }
		// if (creatureName === "Driftback") {
		// 	displayInstructions(
		// 		cockpitScene,
		// 		`All Tasks Complete! This ${creatureName} is happy, healthy, and ready to head home!`,
		// 		12,
		// 		500,
		// 		60,
		// 	)
		// } else {
		// 	displayInstructions(
		// 		cockpitScene,
		// 		`All Tasks Complete! This ${creatureName} is ready to be discharged!`,
		// 		12,
		// 		500,
		// 		60,
		// 	)
		// }

		cockpitScene[`${prefix}DischargeButton`].setVisible(true)
		cockpitScene[`${prefix}DischargeText`]?.setVisible(true)
		cockpitScene[`${prefix}DischargeButton`].setAlpha(1)
		cockpitScene[`${prefix}DischargeText`]?.setAlpha(1)
		cockpitScene[`${prefix}DischargeButton`].input.enabled = true

		cockpitScene.tabletButton.input.enabled = false
		cockpitScene.tabletButton.setAlpha(0.5)
	}

	const setupFuelAndLaunch = () => {
		if (cockpitScene.currentPage === 0 || cockpitScene.currentPage === 4) {
			console.log("GameDone")
			cockpitScene.handleMissionComplete()
		}
		cockpitScene.hideAllFoodTaskGrids("L")
		cockpitScene.LFoodTaskHolder.setVisible(false)
		cockpitScene.taskHeader.setVisible(false)
		cockpitScene.taskHeaderText.setVisible(false)
		cockpitScene.fuelGauge.setTexture("fuelFull")
		cockpitScene.duplicateFuelGauge.setTexture("fuelFull")
		//cockpitScene.tabletNotification.setVisible(false)
		removeNotificationBell(cockpitScene)
		cockpitScene.tabletButton.input.enabled = false
		cockpitScene.tabletButton.setAlpha(0.5)

		//MissionComplete thingy
		if (cockpitScene.currentPlanet === 1 || cockpitScene.currentPlanet === 2) {
			cockpitScene.newMissionCompletePanel()
		}
	}

	// Handle planet 1 progress
	if (currentPlanet === 1) {
		switch (savedMiniLevel) {
			case 0:
				console.log("00: Scan Creature")

				updateMiniLevel(savedMiniLevel)
				cockpitScene.time.delayedCall(2000, () => {


					cockpitScene.showAllFoodTaskGrids("L")
					setupScanComplete()

					displayTooltip(cockpitScene, {
						xPos: cockpitScene.tabletButton.x + 170 * cockpitScene.scaleFactor,
						yPos: cockpitScene.tabletButton.y + 2 * cockpitScene.scaleFactor,
						type: "thisIsYourTabletTip",
						scale: 1,
						text: "This is your [b]Tablet.[/b]\nPress it to see the scan results",
						fontScale: -8,
						xTextOffset: 4,
						yTextOffset: -4,
						wrapWidth: 1.1,
					})

					playNotificationAnimation(cockpitScene,
						{
							xPos: cockpitScene.tabletButton.x + 40 * cockpitScene.scaleFactor,
							yPos: cockpitScene.tabletButton.y - 40 * cockpitScene.scaleFactor
						}
					)

					displayTutorialHand(cockpitScene, {
						xPos: cockpitScene.tabletButton.x + 100 * cockpitScene.scaleFactor,
						yPos: cockpitScene.tabletButton.y - 100 * cockpitScene.scaleFactor,
						rotation: -135,
					})
					// displayInstructions(
					// 	cockpitScene,
					// 	"Scan complete! New tool unlocked: Tablet",
					// 	12,
					// 	300,
					// 	60,
					// )
					cockpitScene.displayOverlay()
				})


				break

			case 1:
				console.log("01: Save Creature Data")
				displayTooltip(cockpitScene, {
					xPos: cockpitScene.tabletButton.x + 120 * cockpitScene.scaleFactor,
					yPos: cockpitScene.tabletButton.y + 2 * cockpitScene.scaleFactor,
					type: "pressActivityTabTip",
					scale: 1,
					text: "[b]New app[/b] unlocked",
					fontScale: -8,
					xTextOffset: +4,
					yTextOffset: -5,
					wrapWidth: 1.1,
				})
				setupIDComplete("left")

				displayTutorialHand(cockpitScene, {
					xPos: cockpitScene.tabletButton.x + 100 * cockpitScene.scaleFactor,
					yPos: cockpitScene.tabletButton.y - 100 * cockpitScene.scaleFactor,
					rotation: -135,
				})
				// displayIndicator(
				// 	cockpitScene,
				// 	cockpitScene.tabletButton.x,
				// 	cockpitScene.tabletButton.y - 8 * cockpitScene.scaleFactor,
				// 	1.3,
				// 	"tablet
				// Indicator",
				// )
				if (cockpitScene.feedTrayOverlayRef) {
					cockpitScene.feedTrayOverlayRef.remove()
				}

				playNotificationAnimation(cockpitScene, {
					xPos: cockpitScene.tabletButton.x + 40 * cockpitScene.scaleFactor,
					yPos: cockpitScene.tabletButton.y - 40 * cockpitScene.scaleFactor
				})
				cockpitScene.displayOverlay()
				break

			case 2:
				console.log("02: Check Field Guide for food type")
				setupFeedTask("Emberfruit", "left")
				// displayIndicator(
				// 	cockpitScene,
				// 	cockpitScene.LFeedMeButton.x - cockpitScene.gameW,
				// 	cockpitScene.LFeedMeButton.y - 5 * cockpitScene.scaleFactor,
				// 	1,
				// 	"feedIndicator",
				// )
				cockpitScene.displayFeedOverlay()
				cockpitScene.taskHeaderText.setVisible(true)
				cockpitScene.taskHeaderText.setText("Emberfruit")
				break

			case 3:
				console.log("Level03")
				cockpitScene.tabletButton.setAlpha(0.5)
				setupDischargeTask("Froststalker", "left")
				displayTooltip(cockpitScene, {
					xPos:
						cockpitScene.LDischargeButton.x -
						cockpitScene.gameW -
						150 * cockpitScene.scaleFactor,
					yPos: cockpitScene.LDischargeButton.y - 10 * cockpitScene.scaleFactor,
					type: "dischargeCrit",
					scale: 1,
					text: "Press to [b]discharge[/b]\nthe Froststalker",
					fontScale: -8,
					xTextOffset: -5,
					yTextOffset: -1,
					wrapWidth: 0.9,
				})

				// displayIndicator(
				// 	cockpitScene,
				// 	cockpitScene.LDischargeButton.x - cockpitScene.gameW,
				// 	cockpitScene.LDischargeButton.y - 5 * cockpitScene.scaleFactor,
				// 	1,
				// 	"dischargeTip",
				// )

				cockpitScene.feedTrayOverlayRef.remove()
				cockpitScene.displayDischargeOverlay()
				break

			case 4:
				console.log("Level04")
				cockpitScene.tooltipText.destroy()
				// displayInstructions(
				// 	cockpitScene,
				// 	"Creature 2 is still waiting! Move on to Tube 2 to care for it!",
				// 	12,
				// 	400,
				// 	60,
				// )
				displayTooltip(cockpitScene, {
					xPos:
						cockpitScene.leftScaleUpButton.x -
						cockpitScene.gameW -
						1 * cockpitScene.scaleFactor,
					yPos:
						cockpitScene.leftScaleUpButton.y + 60 * cockpitScene.scaleFactor,
					type: "stepBackTip",
					scale: 1.1,
					text: "Press this button to\n[b]return[/b] to the cockpit",
					fontScale: -8,
					xTextOffset: 1,
					yTextOffset: 8,
				})
				cockpitScene.leftScaleUpButton.input.enabled = true
				cockpitScene.leftScaleUpButton.setAlpha(1)
				destroyIndicator(cockpitScene)
				break

			case 5:
				console.log("Level05 Email Read and Closed")
				//cockpitScene.tabletNotification.setVisible(false)
				removeNotificationBell(cockpitScene)
				cockpitScene.tabletButton.input.enabled = false
				cockpitScene.tabletButton.setAlpha(0.5)
				destroyIndicator(cockpitScene)
				displayInstructions(
					cockpitScene,
					"Press the left and right arrow buttons to go to the next creature",
					12,
					450,
					60,
				)
				cockpitScene.rightScaleUpButton.input.enabled = true
				break

			case 6:
				console.log("Level06")
				// displayInstructions(
				// 	cockpitScene,
				// 	"Scan complete! Results can be found on your tablet.",
				// 	12,
				// 	400,
				// 	60,
				// )
				destroyInstructions(cockpitScene)
				displayIndicator(
					cockpitScene,
					cockpitScene.tabletButton.x,
					cockpitScene.tabletButton.y,
					1,
					"tabletIndicator",
				)

				displayTutorialHand(cockpitScene, {
					xPos: cockpitScene.tabletButton.x + 100 * cockpitScene.scaleFactor,
					yPos: cockpitScene.tabletButton.y - 100 * cockpitScene.scaleFactor,
					rotation: -135,
				})
				break

			case 7:
				console.log("Level07")
				displayInstructions(
					cockpitScene,
					"ID task complete. Now ‘Assess’ the creature's diet",
					12,
					350,
					60,
				)
				displayIndicator(
					cockpitScene,
					cockpitScene.tabletButton.x,
					cockpitScene.tabletButton.y,
					1,
					"tabletIndicator",
				)
				cockpitScene.rightScaleUpButton.input.enabled = false
				cockpitScene.rightScaleUpButton.setAlpha(0.5)
				//cockpitScene.tabletNotification.setVisible(true)
				playNotificationAnimation(cockpitScene, {
					xPos: cockpitScene.tabletButton.x + 40 * cockpitScene.scaleFactor,
					yPos: cockpitScene.tabletButton.y - 40 * cockpitScene.scaleFactor
				})

				displayTutorialHand(cockpitScene, {
					xPos: cockpitScene.tabletButton.x + 100 * cockpitScene.scaleFactor,
					yPos: cockpitScene.tabletButton.y - 100 * cockpitScene.scaleFactor,
					rotation: -135,
				})

				cockpitScene.tabletButton.input.enabled = true
				cockpitScene.tabletButton.setAlpha(1)
				cockpitScene.changeTaskTexture(1, "taskActive", "right")
				updateMiniLevel(savedMiniLevel)
				break

			case 8:
				console.log("Level08")
				setupFeedTask("Elder Moss", "right")
				break

			case 9:
				console.log("Level09")
				setupDischargeTask("Ice Crawler", "right")
				displayIndicator(
					cockpitScene,
					cockpitScene.RDischargeButton.x - cockpitScene.gameW * 3,
					cockpitScene.RDischargeButton.y - 5 * cockpitScene.scaleFactor,
					1,
					"dischargeTip",
				)
				displayTutorialHand(cockpitScene, {
					xPos: cockpitScene.RDischargeButton.x - cockpitScene.gameW * 3,
					yPos: cockpitScene.RDischargeButton.y - 60 * cockpitScene.scaleFactor,
					rotation: -165,
				})
				break

			case 10:
				console.log("Level10")
				cockpitScene.hideAllFoodTaskGrids("L")
				cockpitScene.LFoodTaskHolder.setVisible(false)
				cockpitScene.taskHeader.setVisible(false)
				cockpitScene.taskHeaderText.setVisible(false)
				cockpitScene.tabletButton.input.enabled = false
				cockpitScene.tabletButton.setAlpha(0.5)
				updateMiniLevel(savedMiniLevel)
				handleGameProgressUpdate(cockpitScene)
				break

			case 11:
				console.log("Level11")
				console.log("Alerts opened", alertsOpened)
				console.log("Emails opened", emailsOpened)

				let requiredEmailsOpened = emailsOpened === 2
				let facialScanOpened = alertsOpened["facialScan"]

				if (facialScanOpened && requiredEmailsOpened) {
					console.log("Facial scan alert and required emails already opened")
					cockpitScene.fuelGauge.setTexture("fuelFull")
					cockpitScene.duplicateFuelGauge.setTexture("fuelFull")
					updateMiniLevel(savedMiniLevel)
					handleGameProgressUpdate(cockpitScene)
				} else {
					console.log(
						"Missing requirements - Facial scan:",
						facialScanOpened,
						"Emails opened:",
						requiredEmailsOpened,
					)

					displayIndicator(
						cockpitScene,
						cockpitScene.tabletButton.x,
						cockpitScene.tabletButton.y - 8 * cockpitScene.scaleFactor,
						1.2,
						"tabletIndicator",
					)

					// Show appropriate message based on what's missing
					let message =
						"Your tablet has a new notification. Please press it"
					if (!facialScanOpened && !requiredEmailsOpened) {
						//message = "Check your Tablet for alerts and emails!"
					} else if (!requiredEmailsOpened) {
						//message = "Check your Tablet for new emails!"
					}

					displayInstructions(cockpitScene, message, 14, 350, 60)

					cockpitScene.tabletButton.input.enabled = true
					cockpitScene.tabletButton.setAlpha(1)
					//cockpitScene.tabletNotification.setVisible(true)
					playNotificationAnimation(cockpitScene, {
						xPos: cockpitScene.tabletButton.x + 40 * cockpitScene.scaleFactor,
						yPos: cockpitScene.tabletButton.y - 40 * cockpitScene.scaleFactor
					})

					displayTutorialHand(cockpitScene, {
						xPos: cockpitScene.tabletButton.x + 100 * cockpitScene.scaleFactor,
						yPos: cockpitScene.tabletButton.y - 100 * cockpitScene.scaleFactor,
						rotation: -135,
					})
				}

				cockpitScene.hideAllFoodTaskGrids("L")
				cockpitScene.LFoodTaskHolder.setVisible(false)
				cockpitScene.taskHeader.setVisible(false)
				cockpitScene.taskHeaderText.setVisible(false)

				break

			case 12:
				cockpitScene.hideAllFoodTaskGrids("L")
				cockpitScene.LFoodTaskHolder.setVisible(false)
				cockpitScene.taskHeader.setVisible(false)
				cockpitScene.taskHeaderText.setVisible(false)
				console.log("Alert Opened")
				cockpitScene.fuelGauge.setTexture("fuelFull")
				cockpitScene.duplicateFuelGauge.setTexture("fuelFull")
				updateMiniLevel(savedMiniLevel)
				handleGameProgressUpdate(cockpitScene)
				break

			case 13:
				console.log("Level13")
				displayInstructions(
					cockpitScene,
					"This planet’s mission is complete! You’ve cared for 2 creatures and earned fuel.\nGo to the cockpit to get ready for takeoff.",
					12,
					500,
					60,
				)
				destroyInstructions(cockpitScene)
				console.log("Alerts opened", alertsOpened)
				requiredEmailsOpened = emailsOpened === 2
				facialScanOpened = alertsOpened["facialScan"]

				if (facialScanOpened && requiredEmailsOpened) {
					console.log("Emails and Alerts Opened")
				} else {
					console.log(
						"Missing requirements - Facial scan:",
						facialScanOpened,
						"Emails opened:",
						requiredEmailsOpened,
					)
				}
				setupFuelAndLaunch()

				// displayInstructions(
				// 	cockpitScene,
				// 	"Your fuel tank is full! Your mission on Hypotherra is complete,\nand you're cleared for takeoff. Prepare to journey to the next planet!",
				// 	12,
				// 	550,
				// 	60,
				// )
				break
		}
	}

	// Handle planet 2 progress
	else if (currentPlanet === 2) {
		switch (savedMiniLevel) {
			case 0:
				console.log("Planet 2 00: Scan Creature")
				displayIndicator(
					cockpitScene,
					cockpitScene.tabletButton.x,
					cockpitScene.tabletButton.y - 8 * cockpitScene.scaleFactor,
					1.2,
					"tabletIndicator",
				)
				updateMiniLevel(savedMiniLevel)
				cockpitScene.hideAllFoodTaskGrids("L")

				cockpitScene.time.delayedCall(1000, () => {
					setupScanComplete()
				})
				break

			case 1:
				console.log("01: Save Creature Data")
				setupIDComplete("left")

				displayInstructions(
					cockpitScene,
					"ID task complete. Now ‘Assess’ the creature's diet",
					12,
					350,
					60,
				)
				displayIndicator(
					cockpitScene,
					cockpitScene.tabletButton.x,
					cockpitScene.tabletButton.y,
					1,
					"tabletIndicator",
				)
				cockpitScene.rightScaleUpButton.input.enabled = false
				cockpitScene.rightScaleUpButton.setAlpha(0.5)
				//cockpitScene.tabletNotification.setVisible(true)
				playNotificationAnimation(cockpitScene, {
					xPos: cockpitScene.tabletButton.x + 40 * cockpitScene.scaleFactor,
					yPos: cockpitScene.tabletButton.y - 40 * cockpitScene.scaleFactor
				})

				displayTutorialHand(cockpitScene, {
					xPos: cockpitScene.tabletButton.x + 100 * cockpitScene.scaleFactor,
					yPos: cockpitScene.tabletButton.y - 100 * cockpitScene.scaleFactor,
					rotation: -135,
				})
				break

			case 2:
				console.log("02: Check Field Guide for food type")
				setupFeedTask("Nebula Noodles", "left")
				break

			case 3:
				console.log("Level03")
				setupDischargeTask("Driftback", "left")

				displayTutorialHand(cockpitScene, {
					xPos:
						cockpitScene.LDischargeButton.x -
						cockpitScene.gameW -
						105 * cockpitScene.scaleFactor,
					yPos: cockpitScene.LDischargeButton.y - 70 * cockpitScene.scaleFactor,
					rotation: 135,
				})
				break

			case 4:
				console.log("Level04")
				// displayInstructions(
				// 	cockpitScene,
				// 	"Creature 2 is still waiting! Move on to Tube 2 to care for it!",
				// 	12,
				// 	400,
				// 	60,
				// )
				destroyInstructions(cockpitScene)
				displayTooltip(cockpitScene, {
					xPos:
						cockpitScene.leftScaleUpButton.x -
						cockpitScene.gameW -
						1 * cockpitScene.scaleFactor,
					yPos:
						cockpitScene.leftScaleUpButton.y + 60 * cockpitScene.scaleFactor,
					type: "stepBackTip",
					scale: 1.1,
					text: "Press this button to\n[b]return[/b] to the cockpit",
					fontScale: -8,
					xTextOffset: 1,
					yTextOffset: 12,
				})

				//cockpitScene.dischargeOverlayRef.remove()
				//cockpitScene.displayReturnOverlay()
				updateMiniLevel(savedMiniLevel)
				handleGameProgressUpdate(cockpitScene)
				break

			case 5:
				console.log("Level05 Email Read and Closed")
				//cockpitScene.tabletNotification.setVisible(false)
				//cockpitScene.tabletButton.input.enabled = false
				destroyIndicator(cockpitScene)
				// displayInstructions(
				// 	cockpitScene,
				// 	"Creature 2 is still waiting! Move on to Tube 2 to care for it!",
				// 	12,
				// 	450,
				// 	60,
				// )
				destroyInstructions(cockpitScene)
				cockpitScene.rightScaleUpButton.input.enabled = true
				break

			case 6:
				console.log("Level06")

				// displayInstructions(
				// 	cockpitScene,
				// 	"Scan complete! Results can be found on your tablet.",
				// 	12,
				// 	400,
				// 	60,
				// )
				//destroyInstructions(this)
				break

			case 7:
				console.log("Level07")
				displayInstructions(
					cockpitScene,
					"ID task complete. Now ‘Assess’ the creature’s diet",
					12,
					450,
					60,
				)
				//cockpitScene.tabletNotification.setVisible(true)
				playNotificationAnimation(cockpitScene, {
					xPos: cockpitScene.tabletButton.x + 40 * cockpitScene.scaleFactor,
					yPos: cockpitScene.tabletButton.y - 40 * cockpitScene.scaleFactor
				})
				cockpitScene.tabletButton.input.enabled = true
				cockpitScene.tabletButton.setAlpha(1)
				cockpitScene.rightScaleUpButton.input.enabled = false
				cockpitScene.rightScaleUpButton.setAlpha(0.5)
				cockpitScene.changeTaskTexture(1, "taskActive", "right")
				updateMiniLevel(savedMiniLevel)
				break

			case 8:
				console.log("Level08")
				setupFeedTask("Beetlefish", "right")
				break

			case 9:
				console.log("Level09")
				setupDischargeTask("Cloudstrider", "right")
				displayIndicator(
					cockpitScene,
					cockpitScene.RDischargeButton.x - cockpitScene.gameW * 3,
					cockpitScene.RDischargeButton.y - 5 * cockpitScene.scaleFactor,
					1,
					"dischargeTip",
				)

				displayTutorialHand(cockpitScene, {
					xPos: cockpitScene.RDischargeButton.x - cockpitScene.gameW * 3,
					yPos: cockpitScene.RDischargeButton.y - 60 * cockpitScene.scaleFactor,
					rotation: -165,
				})
				break

			case 10:
				console.log("Level10")
				cockpitScene.tabletButton.input.enabled = false
				cockpitScene.tabletButton.setAlpha(0.5)
				cockpitScene.taskHeaderText.setVisible(false)
				cockpitScene.hideAllFoodTaskGrids("L")
				updateMiniLevel(savedMiniLevel)
				handleGameProgressUpdate(cockpitScene)
				break

			case 11:
				console.log("Level11")
				displayTooltip(cockpitScene, {
					xPos:
						cockpitScene.rightScaleUpButton.x -
						cockpitScene.gameW * 3 -
						1 * cockpitScene.scaleFactor,
					yPos:
						cockpitScene.rightScaleUpButton.y + 60 * cockpitScene.scaleFactor,
					type: "stepBackTip",
					scale: 1.1,
					text: "Press this button to\n[b]return[/b] to the cockpit",
					fontScale: -8,
					xTextOffset: 1,
					yTextOffset: 8,
				})
				console.log("ReturnTip Displayed")
				//cockpitScene.rightScaleUpButton.input.enabled = false
				//cockpitScene.rightScaleUpButton.setAlpha(0.5)
				// displayInstructions(
				// 	cockpitScene,
				// 	"Looks like your Tablet has a new notification.\nBetter check it out!",
				// 	12,
				// 	400,
				// 	60,
				// )
				//cockpitScene.fuelGauge.setTexture("fuelFull")
				//cockpitScene.duplicateFuelGauge.setTexture("fuelFull")

				//cockpitScene.leftScaleUpButton.input.enabled = true
				//cockpitScene.leftScaleUpButton.setVisible(true)
				//cockpitScene.leftScaleUpButton.setAlpha(1)

				cockpitScene.tabletButton.input.enabled = true
				cockpitScene.tabletButton.setAlpha(1)
				destroyInstructions(cockpitScene)
				//cockpitScene.tabletNotification.setVisible(true)
				playNotificationAnimation(cockpitScene, {
					xPos: cockpitScene.tabletButton.x + 40 * cockpitScene.scaleFactor,
					yPos: cockpitScene.tabletButton.y - 40 * cockpitScene.scaleFactor
				})
				updateMiniLevel(savedMiniLevel)
				handleGameProgressUpdate(cockpitScene)
				break

			case 12:
				// displayInstructions(
				// 	cockpitScene,
				// 	"Creature 3 is still waiting! Move on to Tube 1 to care for it!",
				// 	12,
				// 	400,
				// 	60,
				// )
				//cockpitScene.leftScaleUpButton.input.enabled = true
				//cockpitScene.leftScaleUpButton.setVisible(true)
				//cockpitScene.leftScaleUpButton.setAlpha(1)
				updateMiniLevel(savedMiniLevel)

				cockpitScene.hideAllFoodTaskGrids("L")
				//cockpitScene.tabletButton.input.enabled = false
				//cockpitScene.tabletNotification.setVisible(false)
				console.log("Alert Opened new mini level: " + savedMiniLevel)
				cockpitScene.rightScaleUpButton.input.enabled = false
				cockpitScene.rightScaleUpButton.setAlpha(0.5)

				// Reset left tube tasks
				for (let i = 1; i <= 4; i++) {
					cockpitScene.changeTaskTexture(i, "taskInactive", "left")
				}

				cockpitScene.taskHeaderText.setVisible(false)
				break

			case 13:
				console.log("Level13")
				cockpitScene.rightScaleUpButton.input.enabled = false
				cockpitScene.rightScaleUpButton.setAlpha(0.5)
				cockpitScene.taskHeader.setVisible(false)
				setupScanComplete()
				cockpitScene.hideAllFoodTaskGrids("L")

				break

			case 14:
				console.log("01: Save Creature Data")
				setupIDComplete("left")
				displayInstructions(
					cockpitScene,
					"ID task complete. Now ‘Assess’ the creature's diet",
					12,
					350,
					60,
				)
				break

			case 15:
				console.log("02: Check Field Guide for food type")
				setupFeedTask("Phantom Fungus", "left")
				break

			case 16:
				console.log("Level16")
				setupDischargeTask("Skyray", "left")
				break

			case 17:
				console.log("Level04")
				displayInstructions(
					cockpitScene,
					"That's a wrap on this planet's mission!\nYou've cared for all 3 creatures and earned a well-deserved refuel.",
					12,
					550,
					60,
				)
				destroyInstructions(cockpitScene)
				destroyIndicator(cockpitScene)

				cockpitScene.leftScaleUpButton.input.enabled = false
				cockpitScene.leftScaleUpButton.setAlpha(0.5)
				cockpitScene.tabletButton.input.enabled = true
				cockpitScene.tabletButton.setAlpha(1)

				cockpitScene.rightScaleUpButton.input.enabled = false
				cockpitScene.rightScaleUpButton.setAlpha(0.5)
				cockpitScene.hideAllFoodTaskGrids("R")
				cockpitScene.RFoodTaskHolder.setVisible(false)
				cockpitScene.rightNameTag.setVisible(false)
				cockpitScene.RTaskHeaderText.setVisible(false)
				cockpitScene.RTaskGrid.setVisible(false)

				cockpitScene.fuelGauge.setTexture("fuelFull")
				cockpitScene.duplicateFuelGauge.setTexture("fuelFull")
				//cockpitScene.tabletNotification.setVisible(false)
				removeNotificationBell(cockpitScene)
				cockpitScene.tabletButton.input.enabled = false
				cockpitScene.tabletButton.setAlpha(0.5)
				break

			case 18:
				console.log("Level18")
				setupFuelAndLaunch()
				displayInstructions(
					cockpitScene,
					"Your fuel tank is full! Your mission on Stratosoma is complete,\nand you're cleared for takeoff. Prepare to journey to the next planet!",
					12,
					500,
					60,
				)
				break
		}
	}

	// Handle planet 3 progress
	else if (currentPlanet === 3) {
		switch (savedMiniLevel) {
			case 0:
				console.log("Planet 3 00: Scan Creature")
				updateMiniLevel(savedMiniLevel)
				cockpitScene.LScanButton.setVisible(false)
				cockpitScene.LScanText.setVisible(false)

				cockpitScene.scanError = cockpitScene.add
					.image(
						cockpitScene.taskHeaderText.x - cockpitScene.gameW,
						cockpitScene.taskHeaderText.y + 80 * cockpitScene.scaleFactor,
						"scanError",
					)
					.setOrigin(0.5)
					.setScale(cockpitScene.scaleFactor * 0.4)
					.setDepth(2)

				displayInstructions(
					cockpitScene,
					"Scan incomplete. Check your tablet!",
					12,
					350,
					60,
				)
				//cockpitScene.tabletNotification.setVisible(true)
				playNotificationAnimation(cockpitScene, {
					xPos: cockpitScene.tabletButton.x + 40 * cockpitScene.scaleFactor,
					yPos: cockpitScene.tabletButton.y - 40 * cockpitScene.scaleFactor
				})
				//troubleshootTip
				displayTooltip(cockpitScene, {
					xPos: cockpitScene.tabletButton.x + 120 * cockpitScene.scaleFactor,
					yPos: cockpitScene.tabletButton.y + 2 * cockpitScene.scaleFactor,
					type: "troubleshootTip",
					scale: 1,
					text: "Use your tablet to\nfind and fix (troubleshoot)\nthe problem",
					fontScale: -8,
					xTextOffset: +4,
					yTextOffset: 1,
					wrapWidth: 1.1,
				})

				// cockpitScene.tweens.add({
				// 	targets: cockpitScene.tabletNotification,
				// 	scale: cockpitScene.tabletNotifScale / 2,
				// 	ease: "Back.Out",
				// 	duration: 100,
				// })
				cockpitScene.tabletButton.input.enabled = true
				cockpitScene.tabletButton.setAlpha(1)
				break

			case 1:
				console.log("MIniLevel1")
				break

			case 2:
				console.log("MIniLevel2")
				console.log("Alerts Complete")
				cockpitScene.LScanButton.setVisible(true)
				cockpitScene.LScanText.setVisible(true)
				displayInstructions(
					cockpitScene,
					"Yikes—that's one spiky fella.\nBetter scan them and see how we can help!",
					12,
					400,
					60,
				)
				destroyInstructions(cockpitScene)

				cockpitScene.tabletButton.input.enabled = false
				cockpitScene.tabletButton.setAlpha(0.5)
				//cockpitScene.tabletNotification.setVisible(false)
				removeNotificationBell(cockpitScene)
				cockpitScene.scanError.destroy()
				cockpitScene.LScanButton.input.enabled = true
				if (cockpitScene.notificationBell) {
					cockpitScene.notificationBell.destroy()
				}
				updateMiniLevel(savedMiniLevel)
				displayTooltip(cockpitScene, {
					xPos: cockpitScene.LScanButton.x - cockpitScene.gameW,
					yPos: cockpitScene.LScanButton.y - 65 * cockpitScene.scaleFactor,
					type: "pressToScanTip",
					scale: 1,
					text: "Press to re-scan",
					fontScale: -8,
					xTextOffset: 0,
					yTextOffset: -9,
					wrapWidth: 1.1,
				})
				return

			case 3:
				console.log("00: Scan Creature")
				cockpitScene.LScanButton.setVisible(false)
				cockpitScene.LScanText.setVisible(false)

				cockpitScene.taskHeaderText.setVisible(true)
				cockpitScene.taskHeaderText.setText("???")
				cockpitScene.showAllFoodTaskGrids("L")

				cockpitScene.LTaskGrid.setVisible(true)

				// displayInstructions(
				// 	cockpitScene,
				// 	"Scan complete! Results can be found on your tablet.",
				// 	12,
				// 	400,
				// 	60,
				// )
				destroyInstructions(cockpitScene)

				// cockpitScene.tweens.add({
				// 	targets: cockpitScene.tabletNotification,
				// 	scale: cockpitScene.tabletNotifScale / 2,
				// 	ease: "Back.Out",
				// 	duration: 100,
				// })
				cockpitScene.tabletButton.input.enabled = true
				cockpitScene.tabletButton.setAlpha(1)
				// cockpitScene.tabletNotification.setVisible(true)
				playNotificationAnimation(cockpitScene, {
					xPos: cockpitScene.tabletButton.x + 40 * cockpitScene.scaleFactor,
					yPos: cockpitScene.tabletButton.y - 40 * cockpitScene.scaleFactor
				})
				return

			case 4:
				console.log("01: Save Creature Data")
				displayInstructions(
					cockpitScene,
					"ID task complete. Now ‘Assess’ the creature’s diet",
					12,
					450,
					60,
				)
				playNotificationAnimation(cockpitScene, {
					xPos: cockpitScene.tabletButton.x + 40 * cockpitScene.scaleFactor,
					yPos: cockpitScene.tabletButton.y - 40 * cockpitScene.scaleFactor
				})
				cockpitScene.leftScaleUpButton.input.enabled = false
				cockpitScene.leftScaleUpButton.setAlpha(0.5)
				updateMiniLevel(savedMiniLevel)
				cockpitScene.changeTaskTexture(1, "taskActive", "left")
				return

			case 5:
				console.log("02: Check Field Guide for food type")
				setupFeedTask("Spikumber", "left")
				return

			case 6:
				cockpitScene.changeTaskTexture(3, "taskActive", "left")
				displayInstructions(
					cockpitScene,
					"Well done!",
					12,
					200,
					60,
				)
				//cockpitScene.tabletNotification.setVisible(true)
				playNotificationAnimation(cockpitScene, {
					xPos: cockpitScene.tabletButton.x + 40 * cockpitScene.scaleFactor,
					yPos: cockpitScene.tabletButton.y - 40 * cockpitScene.scaleFactor
				})
				cockpitScene.tabletButton.input.enabled = true
				cockpitScene.LDischargeText.setAlpha(1)
				break

			case 7:
				console.log("Level07")
				cockpitScene.changeTaskTexture(4, "taskActive", "left")
				cockpitScene.LDischargeButton.setVisible(true)
				cockpitScene.LDischargeText.setVisible(true)
				cockpitScene.LDischargeButton.setAlpha(1)
				cockpitScene.LDischargeText.setAlpha(1)
				cockpitScene.LDischargeButton.input.enabled = true
				cockpitScene.LDischargeText.setAlpha(1)

				displayInstructions(
					cockpitScene,
					`All tasks complete! Press ‘DISCHARGE' to let the creature go!`,
					12,
					400,
					60,
				)
				updateMiniLevel(savedMiniLevel)
				return

			case 8:
				//cockpitScene.tabletNotification.setVisible(true)
				console.log("LEVEL 8!!")
				destroyIndicator(cockpitScene)

				updateMiniLevel(savedMiniLevel)
				handleGameProgressUpdate(cockpitScene)
				playNotificationAnimation(cockpitScene, {
					xPos: cockpitScene.tabletButton.x + 40 * cockpitScene.scaleFactor,
					yPos: cockpitScene.tabletButton.y - 40 * cockpitScene.scaleFactor
				})
				break

			case 9:
				console.log("LEVEL 9!!")

				// displayInstructions(
				// 	cockpitScene,
				// 	"Creature 2 is still waiting! Move on to Tube 2 to care for it!",
				// 	12,
				// 	450,
				// 	60,
				// )
				destroyInstructions(cockpitScene)

			

				let levelSavedUserData = checkLocalSavedData()
				let alertsOpened = levelSavedUserData?.alertsOpened || {}
				let allAlerts = ["robotAlert"]
				let unopenedAlerts = allAlerts.filter((alert) => !alertsOpened[alert])

				if (unopenedAlerts.length === 0) {
					if (cockpitScene.notificationBell) {
						cockpitScene.notificationBell.destroy()
					}
					
				} else {
					console.log("Unopened alerts blocking", unopenedAlerts)

				}



				cockpitScene.rightScaleUpButton.input.enabled = true
				break

			case 10:
				console.log("LEVEL 10!!")
				cockpitScene.tabletButton.input.enabled = true
				//cockpitScene.tabletNotification.setVisible(true)
				playNotificationAnimation(cockpitScene, {
					xPos: cockpitScene.tabletButton.x + 40 * cockpitScene.scaleFactor,
					yPos: cockpitScene.tabletButton.y - 40 * cockpitScene.scaleFactor
				})
				cockpitScene.tabletButton.setAlpha(1)
				// displayInstructions(
				// 	cockpitScene,
				// 	"Scan complete! Results can be found on your tablet.",
				// 	12,
				// 	400,
				// 	60,
				// )
				destroyInstructions(cockpitScene)
				break

			case 12:
				console.log("LEVEL 12!!")

				displayInstructions(
					cockpitScene,
					"ID task complete. Now ‘Assess’ the creature’s diet",
					12,
					450,
					60,
				)

				//cockpitScene.tabletNotification.setVisible(true)
				playNotificationAnimation(cockpitScene, {
					xPos: cockpitScene.tabletButton.x + 40 * cockpitScene.scaleFactor,
					yPos: cockpitScene.tabletButton.y - 40 * cockpitScene.scaleFactor
				})
				cockpitScene.tabletButton.input.enabled = true
				cockpitScene.rightScaleUpButton.input.enabled = false
				cockpitScene.rightScaleUpButton.setAlpha(0.5)
				cockpitScene.tabletButton.setAlpha(1)
				cockpitScene.changeTaskTexture(1, "taskActive", "right")
				updateMiniLevel(savedMiniLevel)
				break

			case 13:
				console.log("LEVEL 13!!")
				setupFeedTask("Arachsquid", "right")
				break

			case 14:
				console.log("LEVEL 14!!")

				displayInstructions(
					cockpitScene,
					"Well done!",
					12,
					200,
					60,
				)
				cockpitScene.changeTaskTexture(3, "taskActive", "right")
				//cockpitScene.tabletNotification.setVisible(true)
				playNotificationAnimation(cockpitScene, {
					xPos: cockpitScene.tabletButton.x + 40 * cockpitScene.scaleFactor,
					yPos: cockpitScene.tabletButton.y - 40 * cockpitScene.scaleFactor
				})
				cockpitScene.tabletButton.input.enabled = true
				cockpitScene.tabletButton.setAlpha(1)
				updateMiniLevel(savedMiniLevel)
				break

			case 15:
				console.log("LEVEL 15!!")
				setupDischargeTask("Blazewraith", "right")
				break

			case 16:
				console.log("LEVEL 16!!")

				displayInstructions(
					cockpitScene,
					"Your tablet has a new notification.\nPlease press it.",
					12,
					350,
					60,
				)
				//cockpitScene.fuelGauge.setTexture("fuelFull")
				//cockpitScene.duplicateFuelGauge.setTexture("fuelFull")
				cockpitScene.tabletButton.input.enabled = true
				cockpitScene.tabletButton.setAlpha(1)
				//cockpitScene.tabletNotification.setVisible(true)
				playNotificationAnimation(cockpitScene, {
					xPos: cockpitScene.tabletButton.x + 40 * cockpitScene.scaleFactor,
					yPos: cockpitScene.tabletButton.y - 40 * cockpitScene.scaleFactor
				})
				break

			case 17:
				// console.log("LEVEL 17!!")

				// displayInstructions(
				// 	cockpitScene,
				// 	"Creature 3 is still waiting! Move on to Tube 1 to care for it!",
				// 	12,
				// 	400,
				// 	60,
				// )
				// cockpitScene.leftScaleUpButton.input.enabled = true
				// cockpitScene.leftScaleUpButton.setVisible(true)

				// Reset left tube tasks
				for (let i = 1; i <= 4; i++) {
					cockpitScene.changeTaskTexture(i, "taskInactive", "left")
				}
				updateMiniLevel(savedMiniLevel)
				handleGameProgressUpdate(cockpitScene)
				break

			case 18:
				console.log("LEVEL 18!!")
				setupScanComplete()
				cockpitScene.hideAllFoodTaskGrids("L")
				break

			case 19:
				console.log("LEVEL 19!!")
				setupIDComplete("left")
				playNotificationAnimation(cockpitScene, {
					xPos: cockpitScene.tabletButton.x + 40 * cockpitScene.scaleFactor,
					yPos: cockpitScene.tabletButton.y - 40 * cockpitScene.scaleFactor
				})
				break

			case 20:
				console.log("02: Check Field Guide for food type")
				setupFeedTask("Starfruit Saplings", "left")
				return

			case 21:
				console.log("LEVEL 21!!")
				setupDischargeTask("Smoth", "left")
				break

			case 22:
				console.log("LEVEL22!!")
				// displayInstructions(
				// 	cockpitScene,
				// 	"That's a wrap on this planet's mission!\nYou've cared for all 3 creatures and earned a well-deserved refuel.",
				// 	12,
				// 	550,
				// 	60,
				// )
				// destroyIndicator(cockpitScene)

				// cockpitScene.fuelGauge.setTexture("fuelFull")
				// cockpitScene.duplicateFuelGauge.setTexture("fuelFull")
				// cockpitScene.tabletNotification.setVisible(false)
				// cockpitScene.tabletButton.input.enabled = false
				// cockpitScene.tabletButton.setAlpha(0.5)
				updateMiniLevel(savedMiniLevel)
				handleGameProgressUpdate(cockpitScene)
				break

			case 23:
				console.log("LEVEL 23!!")
				setupFuelAndLaunch()
				// displayInstructions(
				// 	cockpitScene,
				// 	"Your fuel tank is full! Your mission on Emberon is complete,\nand you're cleared for takeoff. Prepare to journey to the next planet!",
				// 	12,
				// 	500,
				// 	60,
				// )
				break
		}
	}
}
